import { NavLink } from 'react-router-dom';
import { Compass, Calendar, MapPin, Users, User } from 'lucide-react';
import styles from './BottomNav.module.css';

/**
 * BottomNav - Fixed bottom tab navigation
 * 
 * Primary navigation for authenticated users.
 * Features glassmorphism styling with active state indicators.
 */
const navItems = [
  { icon: Compass, label: 'Discover', route: '/discover' },
  { icon: Calendar, label: 'Events', route: '/events' },
  { icon: MapPin, label: 'Venues', route: '/venues' },
  { icon: Users, label: 'Social', route: '/social' },
  { icon: User, label: 'Profile', route: '/profile' },
];

export function BottomNav() {
  return (
    <nav className={styles.bottomNav} role="navigation" aria-label="Main navigation">
      {navItems.map((item) => (
        <NavLink
          key={item.route}
          to={item.route}
          className={({ isActive }) =>
            `${styles.navItem} ${isActive ? styles.active : ''}`
          }
        >
          <item.icon size={24} strokeWidth={2} />
          <span className={styles.label}>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}

export default BottomNav;
